export default "__VITE_ASSET__IBiL2La6__"